// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Container_mainContainer__xQrA0"};